/*@flow*/
import history from 'lib/history';
import cleanQuery from 'lib/cleanQuery';
import same from 'lib/same';
import { set, state } from 'ops';
import * as I from 'immutable';
import type { Map } from 'immutable';

type QT = (Map<*, *>) => Map<*, *>;
const QUERY_PATH = '$query';

export default function q(query: Object | QT = {}) {
  let nq: Object;
  const curState = state(QUERY_PATH) || I.Map();

  if (typeof query === 'function') {
    let v = query(curState).toJS();
    nq = cleanQuery(v);
  } else if (typeof query === 'object') {
    nq = cleanQuery(query);
  } else {
    throw new Error('[q] Unknown query type `' + typeof query + '`.');
  }

  if (!same(curState, nq)) {
    set(QUERY_PATH, I.fromJS(nq));
    history.updateQuery(nq);
  }
}
